import React from "react";

export default function ChartsIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 83 73"
      fill="#FFFFFF"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M70.7216 57.1059C72.3533 54.7142 73.3175 51.9467 73.3175 48.94C73.3175 40.4325 65.8637 33.565 56.63 33.565C47.3962 33.565 39.9425 40.4325 39.9425 48.94C39.9425 57.4475 47.3962 64.315 56.5929 64.315C59.8562 64.315 62.8971 63.4267 65.4558 61.9234L77.0258 72.5834L82.2916 67.7317L70.7216 57.1059ZM56.63 57.4817C51.5125 57.4817 47.3591 53.655 47.3591 48.94C47.3591 44.225 51.5125 40.3984 56.63 40.3984C61.7475 40.3984 65.9008 44.225 65.9008 48.94C65.9008 53.655 61.7475 57.4817 56.63 57.4817ZM55.295 28.44C52.5508 28.5084 49.9179 29.055 47.5075 29.9775L45.4679 27.1417L31.3762 48.2567L20.2141 36.23L6.7529 56.0809L0.708313 52.0834L19.25 24.75L30.375 36.7084L45.2083 14.5L55.295 28.44ZM64.8996 30.1484C62.5262 29.1917 59.9675 28.6109 57.2975 28.4742L76.2841 0.833374L82.2916 4.86504L64.8996 30.1484Z"
        fill="white"
      />
    </svg>
  );
}
